import { EntityReference } from '@flows/src/types/FlowsSession';
import { useFlowsSession } from '../../../../../api/getFlowsSessionById';
import useFlowsHelper from '../../../../../hooks/useFlowsHelper';
import { useFlowsRouteParams } from '../../../../../hooks/useFlowsRouteParams';

interface Response {
  getEntity: () => Promise<EntityReference | undefined>;
  isFetching: boolean;
}

const useEntityReference = (
  questionId: string,
  entityIndex?: number,
): Response => {
  const { sessionId } = useFlowsRouteParams();
  const { refetch, isFetching } = useFlowsSession(sessionId);
  const { getGroupByQuestionId } = useFlowsHelper();
  const group = getGroupByQuestionId(questionId);

  const getEntity = async () => {
    const { data } = await refetch();
    const entityReference = data?.entity_references?.find(
      ({ index, entity_type }) =>
        index === entityIndex && entity_type === group.entity_key,
    );
    return entityReference;
  };

  return { getEntity, isFetching };
};

export default useEntityReference;
